<template>
	<div class="fp">
		<div class="fp__elm">
			<!-- ///////////////////// -->
			<!-- SWITCHER -->
			<div class="fp__elm-switcher">
				<div
					@click="onClickBalance"
					:class="
						isChecked
							? 'fp__elm-switcher-on-left'
							: 'fp__elm-switcher-off'
					"
				>
					Баланс
				</div>

				<div
					@click="onClickChannel"
					:class="
						!isChecked
							? 'fp__elm-switcher-on-right'
							: 'fp__elm-switcher-off'
					"
				>
					Каналы
				</div>
			</div>
		</div>

		<!-- ///////////////////// -->
		<!-- LABEL - Balance -->
		<div v-if="isChecked" class="fp__bc">
			<div class="fp__bc-label">Баланс</div>
			<div class="fp__bc-value">{{ formatBalance(payGetBalance) }}</div>
		</div>

		<!-- ///////////////////// -->
		<!-- LABEL - Channels -->
		<div v-else class="fp__bc">
			<div class="fp__bc-label">Купленных каналов</div>
			<div class="fp__bc-value">
				<IconWhatsApp class="fp__bc-value-icon" />
				{{ payActivatedChannels.count }}
			</div>
		</div>

		<!-- Разделительная линия -->
		<div class="fp__line"></div>

		<!-- ///////////////////// -->
		<!-- Сумма поплнения -->
		<div class="fp__amount">
			<div class="fp__amount-wrap">
				<!-- label -->
				<div class="fp__amount-wrap-label">
					<div v-if="isChecked">Сумма пополнения</div>
					<div v-else>Купить каналы WhatsApp</div>
				</div>

				<!-- Выпадающий список -->
				<div class="fp__amount-wrap-select">
					<UiNumberInput
						v-if="isChecked"
						label="Введите сумму"
						:is-error="isInputBalanceError"
						v-on:input-balance="onInputBalance"
					/>

					<UiNumberSelect
						v-else
						:total="100"
						:default-value="1"
						v-on:selected-value="selectedAmountChannels"
					/>
				</div>

				<!-- Кнопка -->
				<UiButton
					v-if="isChecked"
					class="fp__amount-wrap-btn"
					@click="onClickToUpBalance"
					label="Пополнить"
					background-color="var(--theme-color)"
					border-color="var(--theme-color)"
					color="rgb(255, 255, 255)"
					font-weight="600"
					font-size="16px"
				/>

				<UiButton
					v-else
					class="fp__amount-wrap-btn"
					@click="onClickPayChannels"
					:label="'Оплатить ' + formatBalance(channelCost)"
					background-color="var(--theme-color)"
					border-color="var(--theme-color)"
					color="rgb(255, 255, 255)"
					font-weight="600"
					font-size="16px"
				/>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconWhatsApp from "@/components/icons/IconWhatsApp.vue";
import UiCurrencySelect from "@/components/ui/UiCurrencySelect.vue";
import UiNumberSelect from "@/components/ui/UiNumberSelect.vue";
import UiButton from "@/components/ui/UiButton.vue";
import { mapActions, mapGetters } from "vuex";
import { IPaymentChannelDetail } from "@/interfaces/IPaymentChannelDetail";
import UiNumberInput from "@/components/ui/UiNumberInput.vue";

@Options({
	components: {
		UiNumberInput,
		UiButton,
		UiNumberSelect,
		UiCurrencySelect,
		IconWhatsApp,
	},

	computed: {
		...mapGetters("paymentModule", {
			payChannelDetail: "payChannelDetailGetters",
			payChannel: "payChannelGetters",
			payActivatedChannels: "payActivatedChannelsGetters",
			payBalance: "payBalanceGetters",
			payGetBalance: "payGetBalanceGetters",
		}),
	},

	methods: {
		...mapActions("paymentModule", [
			"payChannelDetailAction",
			"payChannelAction",
			"payBalanceAction",
			"payActivatedChannelsAction",
			"payGetBalanceAction",
		]),
	},
})
export default class FormPayment extends Vue {
	// TODO - временно. Нужно будет вернуть isChecked = true
	isChecked = false;

	isInputBalanceError = false;
	channelCost = 0;
	channelAmount = 0;
	inputBalanceValue = "";

	// Const declaration
	public readonly PAY_TYPE = { BALANCE: 0, CHANNEL: 1 };

	// ************************************************************
	// Define mapGetters
	public payChannelDetail: IPaymentChannelDetail;
	public payChannel: { createdId: number; url: string };
	public payBalance: { createdId: number; url: string };
	public payActivatedChannels: { count: number };
	public payGetBalance: number;

	// ************************************************************
	// Define mapActions
	public payChannelDetailAction!: () => Promise<void>;

	public payChannelAction!: (payload: {
		amount: number;
		type: number;
	}) => Promise<void>;

	public payBalanceAction!: (payload: { amount: number }) => Promise<void>;

	public payActivatedChannelsAction!: () => Promise<void>;
	public payGetBalanceAction!: () => Promise<void>;

	/**
	 * Hook mounted
	 */
	public async mounted() {
		this.isInputBalanceError = false;

		// < TODO код который ниже, нужно будет убать.
		await this.payActivatedChannelsAction();
		await this.payGetBalanceAction();
		await this.payChannelDetailAction();

		// Рассчитываем стоимость для одного канала
		const amountChannels = 1;
		this.calculateChannelCost(amountChannels);
		// TODO />
	}

	/**
	 * Клик по вкладке баланс
	 */
	public async onClickBalance() {
		this.isChecked = true;
		this.isInputBalanceError = false;
		this.$emit("is-balance", this.isChecked);
	}

	/**
	 * Клик по вкладке каналы
	 */
	public async onClickChannel() {
		this.isChecked = false;
		this.$emit("is-balance", this.isChecked);
		await this.payActivatedChannelsAction();
		await this.payChannelDetailAction();

		// Рассчитываем стоимость для одного канала
		const amountChannels = 1;
		this.calculateChannelCost(amountChannels);
	}

	/**
	 * Форматирование цены
	 * @param balance
	 */
	public formatBalance(balance: number) {
		return Intl.NumberFormat("ru-Ru", {
			currency: "RUB",
			style: "currency",
		}).format(balance);
	}

	/**
	 * Выбранное количество каналов из выпадаюшего списка
	 * @param amount
	 */
	public selectedAmountChannels(amount: number) {
		this.calculateChannelCost(amount);
	}

	/**
	 * Рассчитать стоимость каналов
	 */
	public calculateChannelCost(amount: number) {
		const tariff = this.payChannelDetail.tariff;
		this.channelAmount = amount;
		this.channelCost = tariff.cost * this.channelAmount;
	}

	/**
	 * Клик по кнопке - Оплатить (оплата за каналы)
	 */
	public async onClickPayChannels() {
		const amount = this.channelAmount;

		await this.payChannelAction({
			amount: amount,
			type: this.PAY_TYPE.CHANNEL,
		});

		if (this.payChannel.url !== "") {
			window.location.href = this.payChannel.url;
		}
	}

	/**
	 * Обработка ввода баланса
	 * @param value
	 */
	public onInputBalance(value: string) {
		const isDigitsOnly = /^\d+$/.test(value);
		this.isInputBalanceError = !isDigitsOnly;
		this.inputBalanceValue = value;
	}

	/**
	 * Клик по кнопке - Оплатить (пополнение баланса)
	 */
	public async onClickToUpBalance() {
		const isDigitsOnly = /^\d+$/.test(this.inputBalanceValue);

		if (!isDigitsOnly) {
			this.isInputBalanceError = true;
			return;
		} else {
			this.isInputBalanceError = false;
		}

		const amount = Number(this.inputBalanceValue);

		await this.payBalanceAction({ amount });

		if (this.payBalance.url !== "") {
			window.location.href = this.payBalance.url;
		}
		// Запрос на пополнение
	}
}
</script>

<style scoped lang="scss">
.fp {
	padding: 24px;
	background: rgb(255, 255, 255);
	border-radius: 12px;
	box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.02);

	&__elm {
		display: flex;
		justify-content: center;
	}

	&__elm-switcher {
		display: flex;
		justify-content: center;
		border: 2px solid rgb(223, 230, 238);
		border-radius: 12px;
		background: rgb(244, 246, 250);
	}

	&__elm-switcher-on-left {
		padding: 12px 14px;
		cursor: pointer;
		color: rgb(49, 49, 50);
		background: rgb(255, 255, 255);
		border-radius: 12px;
		box-shadow: 4px 0 12px rgba(0, 0, 0, 0.09);

		// Анимация
		animation-duration: 0.6s;
		animation-name: appearance-animation-modal;
	}

	&__elm-switcher-on-right {
		padding: 12px 14px;
		cursor: pointer;
		color: rgb(49, 49, 50);
		background: rgb(255, 255, 255);
		border-radius: 12px;
		box-shadow: -4px 0 12px rgba(0, 0, 0, 0.09);

		// Анимация
		animation-duration: 0.6s;
		animation-name: appearance-animation-modal;
	}

	&__elm-switcher-off {
		padding: 12px 14px;
		cursor: pointer;
		border-radius: 8px;
		color: rgb(119, 121, 124);
	}

	// Balance, Channels
	&__bc {
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	&__bc-label {
		padding: 24px 0 12px;
		color: rgb(119, 121, 124);
		font-size: 14px;
	}

	&__bc-value {
		display: flex;
		color: rgb(49, 49, 50);
		font-size: 24px;
		font-weight: 600;
	}

	&__bc-value-icon {
		padding-right: 12px;
	}

	&__line {
		padding-top: 12px;
		border-bottom: 1px solid rgb(223, 230, 238);
	}

	// Сумма пополнения
	&__amount {
		display: flex;
		padding: 24px 0 0;
		justify-content: center;
	}

	&__amount-wrap {
		min-width: 220px;
		//border: 1px solid #333;
	}

	&__amount-wrap-label {
		padding-bottom: 10px;
		font-size: 14px;
		color: rgb(49, 49, 50);
	}

	&__amount-wrap-select {
		cursor: pointer;
	}

	&__amount-wrap-btn {
		padding: 16px 0;
	}

	@media screen and (max-width: 768px) {
		padding: 12px;

		&__elm {
			display: block;
		}

		&__elm-switcher-on-left {
			display: flex;
			flex-grow: 1;
			justify-content: center;
		}

		&__elm-switcher-on-right {
			display: flex;
			flex-grow: 1;
			justify-content: center;
		}

		&__elm-switcher-off {
			display: flex;
			flex-grow: 1;
			justify-content: center;
		}

		&__amount {
			display: block;
			padding: 24px 0 0;
		}

		&__amount-wrap-btn {
			padding: 16px 0 4px;
		}
	}
}

@keyframes appearance-animation-modal {
	0% {
		opacity: 0.5;
	}
	100% {
		opacity: 1;
	}
}
</style>
